import { Calendar } from 'antd';
import generateCalendar from 'antd/es/calendar/generateCalendar';
export { generateCalendar };
export default Calendar;
